module.exports = __webpack_public_path__ + "img/cynthia-del-rio.f7c4b2dd.jpg";